import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { QueryClient } from './Client.service';
import { IMovement } from './Movement.service';

export interface IMonitoramentoScrollBack {
	id: number;
	temperature: number | null;
	humidity: number | null;
	ventilation: number | null;
	atmosferaControlada: boolean;
	nivelCo2: string | null;
	return: number | null;
	supply: number | null;
	observation: string | null;
	images: string[] | null;
	problems: number[] | null;
	date: string;
	created_at: string;
	updated_at: string;
}

export interface IManutencaoScrollBack {
	id: number;
	maintenance_types: number[] | null;
	description: string;
	date: string;
	hh: number | null;
	voltage: string | null;
	size: string | null;
	manufactory: string | null;
	container: string;
	block: string | null;
	batch: string | null;
	place: string | null;
	images: string[] | null;
	yard: {
		id: number;
		name: string;
	};
	materials: {
		id: number;
		quantity: number;
	}[];
}

export interface IContainerScrollBack {
	id: number;
	label: string;
	temperature: number | null;
	humidity: number | null;
	ventilation: number | null;
	atmosferaControlada: boolean;
	nivelCo2: string | null;
	return: number | null;
	supply: number | null;
	position: string | null;
	carrier: string | null;
	owner: string | null;
	ownerUser: string | null;
	isArrive: boolean;
	dateArrive: string | null;
	isLeave: boolean;
	dateLeave: string | null;
	createdAt: string;
	updatedAt: string;
	movement: {
		id: number;
		uuid: string;
		date: string;
		arrived: boolean;
		travelCode: string;
		created_at: string;
		updated_at: string;
		yard: {
			id: number;
			name: string;
		};
		ship: {
			id: number;
			name: string;
			owner: string;
		};
	};
	monitorings: IMonitoramentoScrollBack[];
	maintenances: IManutencaoScrollBack[];
}

export type FormatoExportacaoScrollBack = 'pdf' | 'xlsx';

export interface IContainer {
	id: number;
	label: string;
	temperature: string;
	humidity?: string | number | null;
	ventilation?: string | number | null;
	atmosferaControlada?: boolean;
	nivelCo2?: string | number | null;
	return?: string | number | null;
	supply?: string | number | null;
	dateArrive: Date;
	movement: Partial<IMovement>;
	carrier: string;
	position?: string;
	owner?: string;
	isArrive?: boolean;
	isLeave?: boolean;
	dateLeave?: Date;
	actions?: any;
}

abstract class ContainerService {
	static async getAll(
		params: QueryClient,
		yardId?: number
	): Promise<PaginationContent<IContainer> | undefined> {
		try {
			const response: PaginationContent<IContainer> = await request(
				'/containers',
				'get',
				{
					params: { yardId, ...params },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async getAllByYard(yardId: number) {
		try {
			const response = await request(`/containers/yard/${yardId}`, 'get');
			return response;
		} catch (error: any) {}
	}

	static async getScrollBack(
		container: string,
		idYard: number
	): Promise<IContainerScrollBack | undefined> {
		try {
			const response: IContainerScrollBack = await request(
				'/containers/scroll-back',
				'get',
				{ params: { container, idYard } }
			);
			return response;
		} catch (error: any) {}
	}

	static async exportarScrollBack(
		container: string,
		idYard: number,
		formato: FormatoExportacaoScrollBack
	): Promise<Blob | undefined> {
		try {
			const resposta: Blob = await request(
				'/containers/scroll-back/export',
				'get',
				{
					params: { container, idYard, format: formato },
					responseType: 'blob',
				}
			);
			return resposta;
		} catch (error: any) {}
	}

	static async getInfoByEmail(email: string) {
		try {
			const response = await request(`/containers/info/${email}`, 'get');
			return response;
		} catch (error: any) {}
	}

	static async deactivate(ids: number[]) {
		try {
			await request('/containers/deactivate', 'post', {
				data: {
					ids,
				},
			});
			return true;
		} catch (error: any) {}
	}

	static async activate(ids: number[]) {
		try {
			await request('/containers/activate', 'post', {
				data: {
					ids,
				},
			});
			return true;
		} catch (error: any) {}
	}

	static async dashboard(dateBegin: Date, dateEnd: Date) {
		try {
			const response = await request(`/containers/dashboard`, 'get', {
				params: {
					dateBegin,
					dateEnd,
				},
			});
			return response;
		} catch (error: any) {}
	}

	static async getDashboardInfo(
		startDate: Date,
		endDate: Date,
		clientId: string
	) {
		try {
			const response = await request(`/containers/dashboard/v2`, 'get', {
				params: {
					date_initial: startDate.toISOString(),
					date_final: endDate.toISOString(),
					id_client: clientId,
				},
			});
			return response;
		} catch (error: any) {}
	}

	static async getReturnContainers(
		params: QueryClient,
		yardId?: number,
		shipId?: number,
		travelCode?: string
	): Promise<PaginationContent<IContainer> | undefined> {
		try {
			const response = await request('/containers/return', 'get', {
				params: {
					yardId,
					shipId,
					travelCode,
					...params,
				},
			});
			return response;
		} catch (error: any) {
			console.log(error);
		}
	}
}

export default ContainerService;
